app.controller('patientListController', ['$rootScope', '$scope', '$state', '$stateParams', '$translate', '$mdDialog', 'config', 'objectHelper', 'baseModel', 'applicationModel', 'patientModel', 'userModel', 'visitModel',
    function ($rootScope, $scope, $state, $stateParams, $translate, $mdDialog, config, objectHelper, baseModel, applicationModel, patientModel, userModel, visitModel) {


        function setData() {
            $scope.patients = [];

            $scope.criteria = new PatientDataGridCriteria();
            $scope.criteria.clinicId = userModel.currentUser.clinicId;

            // fixme - what about width?
            $scope.columns = [
                {
                    field: "fileNumber",
                    displayName: $translate.instant('T.MODULE.PERSONAL_DATA.FILE_NUMBER')
                },
                {
                    field: "lastName",
                    displayName: $translate.instant('T.MODULE.PERSONAL_DATA.LAST_NAME')
                },
                {
                    field: "firstName",
                    displayName: $translate.instant('T.MODULE.PERSONAL_DATA.FIRST_NAME')
                },
                {
                    cellTemplate: 'edm/application/view/app/patient/grid-template/data-patient-list-row-gender-type.html'
                },
                {
                    field: "identifier + ' (' + (identifierType | prefix:'T.ENUM.IDENTIFIER_TYPE.' | translate) + ')'",
                    displayName: $translate.instant('T.MODULE.PERSONAL_DATA.IDENTIFIER')
                },
                {
                    field: "phone",
                    displayName: "T.DATA.PHONE"
                }
                //,{
                //    cellTemplate: 'edm/application/view/app/patient/grid-template/data-patient-list-delete-patient.html'
                //}
            ];

            if(!config.MEEDY) {
                $scope.buttons = [
                    //{
                    //    icon: 'content:add',
                    //    buttonClass: ['md-fab', 'md-primary', 'patient-list-add-button', 'md-mini'],
                    //    action: 'createNewPatient'
                    //}
                ];
            }

            $scope.createNewPatient = function() {
                $state.go(Constant.STATE.APP.PATIENT.CREATE);
            };
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.PATIENT.GET_DATA_PAGE.SUCCESS, function (event, dataPage) {
                $scope.patients = dataPage.data;
                $scope.numberOfPages = (!dataPage.numberOfPages) ? 1 : dataPage.numberOfPages;
            });

            $scope.$on(Event.PATIENT.DELETE.SUCCESS, function() {
                patientModel.getDataPage($scope.criteria);
            })
        }

        function setActions() {
            $scope.criteriaChanged = function () {
                patientModel.getDataPage($scope.criteria);
            };

            $scope.viewPatient = function (patient) {
                $state.go(Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA, {patientId: patient.id});
            };

            $scope.deletePatient = function(patient) {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MODULE.PATIENT.DELETE_PATIENT_CONFIRMATION'),
                    ok: $translate.instant('T.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    patientModel.delete(patient);
                }, function() {
                    return false;
                });
            }



        }

        function configureInterface() {

        }

        function initialize() {
            applicationModel.fillViewportMode = true;
            patientModel.getDataPage($scope.criteria);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
